import { kitResultsViewable } from '@repo/utils';
import { useSelector } from 'react-redux';
import { getTinyAccountById } from 'store/account';
import { getKitById } from 'store/kits';
import { getImpersonateId } from 'store/user';
import useGetKitIdParam from './useGetKitIdParam';

export const useCurrentKitAndTinyAccount = () => {
  const currentKitId = useGetKitIdParam();

  const currentKit = useSelector(getKitById(currentKitId));
  const currentTinyAccountId = currentKit?.tinyaccount_id;
  const currentTinyAccount = useSelector(
    getTinyAccountById(currentTinyAccountId),
  );
  const impersonateId = useSelector(getImpersonateId);
  return {
    currentKit,
    currentKitId: currentKitId,
    currentTinyAccount,
    currentTinyAccountId: currentTinyAccount?.id ? currentTinyAccount.id : null,
    currentKitType: currentKit?.sampling_type,
    currentKitStatus: currentKit?.status,
    currentKitIsBabySample:
      currentKit?.age_at_sampling && currentKit?.age_at_sampling < 365,
    currentKitHasResults:
      currentKit && kitResultsViewable(currentKit, !!impersonateId),
  };
};
export default useCurrentKitAndTinyAccount;
